import uiLocale from '../../../utils/UILocale.js';

const translations = {
  offerCodeTitle: uiLocale.getString('component.coupons.offer_code_title'),
  offerCodeApplied: uiLocale.getString('component.coupons.offer_code_applied'),
  offerCodeLabel: uiLocale.getString('component.coupons.offer_code_label'),
  offerCodeNotRecognised: uiLocale.getString('component.coupons.offer_code_not_recognised'),
  offerCodeTryAgain: uiLocale.getString('component.coupons.offer_code_try_again'),
  offerCodeApply: uiLocale.getString('component.coupons.offer_code_apply'),
  offerCodeMinLengthError: uiLocale.getString('component.coupons.offer_code_minlength_error'),
  orderSummaryDisountLabel: uiLocale.getString('component.coupons.offer_code_discount_title'),
  orderSummaryAmountDueLabel: uiLocale.getString('component.coupons.amount_due'),
  orderSummaryIncludeVatLabel: uiLocale.getString('component.coupons.include_vat'),
  orderSummaryNoResponse: uiLocale.getString('component.coupons.no_response_from_php_for_60s')
};

export default translations;
